import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '../core/sidenav/sidenav.service';

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  // animations: [routerTransition],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AnalyticsComponent implements OnInit {
  constructor(private readonly sidenav: SidenavService) {
    this.sidenav.opened = true;
  }

  ngOnInit(): void {}
}
